import Keycloak from 'keycloak-js';

import parseOrganizationRoles from './organizationRolesParser';

type OrganizationMapping = {
  [key: string]: {
    name: string;
    roles: string[];
  };
};

export const getOrganization = (keycloak: Keycloak, organizationId: string) => {
  const organizationRoles = parseOrganizationRoles(keycloak);

  if (!organizationRoles) {
    return null;
  }

  return organizationRoles[organizationId];
};

export const getOrganizations = (keycloak: Keycloak) => {
  const organizationRoles = parseOrganizationRoles(keycloak);

  if (!organizationRoles) {
    return [];
  }

  const orgsFromToken: OrganizationMapping = organizationRoles;

  return Object.entries(orgsFromToken).map(([key, value]) => {
    return {
      id: key,
      name: value.name,
    };
  });
};
